





// eslint-disable-next-line no-unused-vars
import { Tree } from 'element-ui';

import { DmsBaseComponent } from '#components/dms/common/base';

export default DmsBaseComponent.extend({
	name: 'DmsTree',
	props: {
		treeProps: { type: Object, required: true },
		treeData: { type: Array, required: true },
		nodeKey: { type: String, required: true },
		checkedData: { type: Array },
	},
	methods: {
		reset() {
			(this.$refs.mainTree as Tree).setCheckedKeys([]);
		},
		getChecked() {
			return (this.$refs.mainTree as Tree).getCheckedNodes();
		},
		getHalfCheckedNodes(){
			return (this.$refs.mainTree as Tree).getHalfCheckedNodes();			
		},
		setCheckedKeys(nodeIds:number[], leafNodeOnly:boolean) {
			(this.$refs.mainTree as any).setCheckedKeys(nodeIds, leafNodeOnly)
		}
	},
});
